import React from 'react';
import { motion } from 'framer-motion';
import FuzzyText from './FuzzyText';
import PhysicsLanyard from './PhysicsLanyard';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero snap-section" id="hero">
      <div className="hero-content">
        <motion.div
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          CLOUD ENGINEER · INFRASTRUCTURE · DISTRIBUTED SYSTEMS
        </motion.div>
        
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <FuzzyText text="ANIKET SHETTY" />
        </motion.h1>
        
        <motion.p
          className="hero-description"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          Building resilient, scalable cloud infrastructure with a systems-first mindset.
        </motion.p>
        
        <motion.div
          className="hero-cta"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.8 }}
        >
          <motion.button 
            className="cta-primary"
            onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            View Work
          </motion.button>
          <motion.button 
            className="cta-secondary"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get In Touch
          </motion.button>
        </motion.div>
      </div>
      
      {/* Lanyard integrated in hero section */}
      <div className="hero-lanyard">
        <PhysicsLanyard />
      </div>
    </section>
  );
};

export default Hero;
